import { render, staticRenderFns } from "./ZonePriceHead.vue?vue&type=template&id=081f4e52&scoped=true"
import script from "./ZonePriceHead.vue?vue&type=script&lang=js"
export * from "./ZonePriceHead.vue?vue&type=script&lang=js"
import style0 from "./ZonePriceHead.vue?vue&type=style&index=0&id=081f4e52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f4e52",
  null
  
)

export default component.exports